document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(".rc-container-wrapper") === null) {
    document.querySelectorAll(".product-form__submit").forEach(function (btn) {
      btn.removeAttribute("disabled");
    });
  }
});

var checkExist = setInterval(function () {
  if (document.querySelector(".rc-container-wrapper")) {
    clearInterval(checkExist);

    let noSub = "Single";

    let hidePrice = document.querySelector(".price__wrapper");
    let variants = document.querySelectorAll(
      ".product__section .product-form__input input"
    );
    let rechargeForm = document.querySelector(".rc-container-wrapper");
    let initialCheckedValue = document.querySelector(
      ".variants__picker input:checked"
    );

    hidePrice.classList.add("hidden_regular");

    variants.forEach((variant) =>
      variant.addEventListener("click", (e) => {
        var vv = e.target.value.toString();
        hidePrice.classList.add("hidden_regular");
        if (vv.indexOf(noSub) >= 0) {
          if (rechargeForm) {
            rechargeForm.style.display = "none";
          }
          var rcInputEl = document.querySelector(
            ".rc_widget__option--onetime input"
          );
          if (rcInputEl) {
            rcInputEl.click();
          }
        } else {
          if (rechargeForm) {
            rechargeForm.style.display = "block";
          }
        }
      })
    );

    var bb = "";
    if (initialCheckedValue) {
      bb = initialCheckedValue.value.toString();
    }
    hidePrice.classList.add("hidden_regular");
    if (bb.indexOf(noSub) >= 0) {
      rechargeForm.style.display = "none";
      document.querySelector(".rc_widget__option--onetime input").click();
    } else {
      rechargeForm.style.display = "block";
    }
  }

  var learnMoreLinks = document.querySelectorAll(".rc_popup__learn_more");
  learnMoreLinks.forEach(function (link) {
    link.setAttribute("href", "/pages/subscription");
  });

  var chatIframe = document.getElementById("dummy-chat-button-iframe");
  if (chatIframe) {
    chatIframe.style.bottom = "0";
  }

  var chatTitles = document.querySelectorAll(".chat-title");
  chatTitles.forEach(function (title) {
    title.textContent = "Chat";
  });
}, 100);

var checkYotpo = setInterval(function () {
  let rechargeForm = document.querySelector(".rc-container-wrapper");

  var yotpoTitles = document.querySelectorAll(".yotpo-header-title");
  if (yotpoTitles.length > 0) {
    var firstTitle = yotpoTitles[0];
    var firstReplacement = document.createElement("h3");
    firstReplacement.className = "yotpo-header-title y-label";
    firstReplacement.textContent = "WRITE A REVIEW";
    firstTitle.parentNode.replaceChild(firstReplacement, firstTitle);
  }
  if (yotpoTitles.length > 1) {
    var lastTitle = yotpoTitles[yotpoTitles.length - 1];
    var lastReplacement = document.createElement("h3");
    lastReplacement.className = "yotpo-header-title y-label";
    lastReplacement.textContent = "ASK A QUESTION";
    lastTitle.parentNode.replaceChild(lastReplacement, lastTitle);
  }

  let lastUrl = location.href;
  if (
    lastUrl.indexOf("/products/") >= 0 ||
    lastUrl.indexOf("products_preview") >= 0
  ) {
    if (rechargeForm) {
      rechargeForm.style.display = "none";
    }
  }

  clearInterval(checkYotpo);
}, 1000);

// Product page scroll up and down.
let current = window.location.href;

// recharge no customer found page add return to account
if (current.indexOf("no_shopify_customer_found/") >= 0) {
  var rcTitleBar = document.querySelector(".rc_title-bar");
  if (rcTitleBar) {
    var p = document.createElement("p");
    var a = document.createElement("a");
    a.href = "/account";
    a.textContent = "Return to account";
    p.appendChild(a);
    rcTitleBar.appendChild(p);
  }
}

const DetailsFirst = `
    position: relative;
	top: -24px;
	left: 50px;
  `;
const DetailsSecond = `
    position: relative;
	top: -24px;
	left: 60px;
  `;
const DetailsThird = `
    position: relative;
	top: -24px;
	left: 80px;
  `;
const DetailsLast = `
    position: relative;
	top: -24px;
	left: 50px;
  `;
const widthfull = `
	width:100%
   `;
const menuListFlex = `
    display: flex;
    justify-content: flex-end;
	`;
const ProductFlex = `
	align-items: flex-end;
	`;
// check browser version

navigator.sayswho = (function () {
  var ua = navigator.userAgent;
  var tem;
  var M =
    ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) ||
    [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return "IE " + (tem[1] || "");
  }
  if (M[1] === "Chrome") {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
  return M.join(" ");
})();

if (navigator.sayswho.indexOf("Safari") >= 0) {
  var version = navigator.sayswho.split(" ");
  version = parseInt(version[1]);

  if (version <= 14) {
    document
      .querySelector(".header-submenu-for-Shop")
      .classList.add("submenu-safari");
    document
      .querySelector(".header-submenu-for-Blog")
      .classList.add("submenu-safari");
    document
      .querySelector(".shop-menu-featured-products")
      .classList.add("full-width-safari");
    document
      .querySelector("#Details-HeaderMenu-1")
      .classList.add("safari-padding");
    document
      .querySelector("#Details-HeaderMenu-2")
      .classList.add("safari-padding");
    document
      .querySelector("#Details-HeaderMenu-3")
      .classList.add("safari-padding");
    document.querySelector("#Details-HeaderMenu-1 .header-caret-icon").style =
      DetailsFirst;
    document.querySelector("#Details-HeaderMenu-2 .header-caret-icon").style =
      DetailsSecond;
    document.querySelector("#Details-HeaderMenu-3 .header-caret-icon").style =
      DetailsThird;
    document.querySelector(".shop-menu-featured-products").style = widthfull;
    if (document.querySelector("#HeaderMenu-MenuList-1")) {
      document.querySelector("#HeaderMenu-MenuList-1").style = menuListFlex;
    }
    if (document.querySelector(".quantity_plus_product")) {
      document.querySelector(".quantity_plus_product").style = ProductFlex;
    }
  } else {
    if (document.querySelector("#HeaderMenu-MenuList-1")) {
      document.querySelector("#HeaderMenu-MenuList-1").style = menuListFlex;
    }

    if (document.querySelector(".quantity_plus_product")) {
      document.querySelector(".quantity_plus_product").style = ProductFlex;
    }
  }
}

const triggers = [
  ".redeem-points-extended",
  ".manage-rewards--link",
  ".redeem-ur-points",
];

triggers.forEach((selector) => {
  document.querySelectorAll(selector).forEach((el) => {
    el.addEventListener("click", function (e) {
      e.preventDefault();

      const swellTabs = document.querySelectorAll(".swell-tab");
      const lastTab = swellTabs[swellTabs.length - 1];

      if (lastTab) {
        lastTab.click();
      }
    });
  });
});

/* ============================================================
   QUICK ADD TO CART (single-variant product cards)
   ============================================================ */
document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-quick-add-variant]');
  if (!btn) return;

  e.preventDefault();

  const variantId = parseInt(btn.dataset.quickAddVariant, 10);
  if (!variantId) return;

  const originalText = btn.textContent.trim();
  btn.disabled = true;
  btn.textContent = 'Adding…';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 }),
  })
    .then(function (res) {
      if (!res.ok) throw new Error('cart_add_failed');
      return res.json();
    })
    .then(function () {
      btn.textContent = 'Added!';
      var notification = document.querySelector('cart-notification');
      if (notification && typeof notification.productJustAddedToCartByQuickAdd === 'function') {
        notification.productJustAddedToCartByQuickAdd();
      }
      setTimeout(function () {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);
    })
    .catch(function () {
      btn.textContent = originalText;
      btn.disabled = false;
    });
});
